var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view',{staticClass:"code"},[_c('view',{staticClass:"text"},[_vm._v("处理中...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }